import { Directive } from '@angular/core';

@Directive({
  selector: 'tree-node'
})
export class TreeNodeDirective {}
